<template lang="html">
  <div class="ChunkSiblings">
    <ChunkSiblingElement v-for="chunk in chunks" :key="chunk.id" :chunk='chunk' :current="current.id==chunk.id"/>
  </div>
</template>

<script>
import ChunkSiblingElement from '@/components/ChunkSiblingElement'
import { mapGetters } from 'vuex'

export default {
  name: 'ChunkSiblings',
  components: {
    ChunkSiblingElement
  },
  props: ['chunks', 'textOnly', 'current'],
  computed: {
    ...mapGetters([
      'videoByID',
    ]),
  }
}
</script>

<style lang="css" scoped>
.ChunkSiblings {
  margin-left: 1rem;
  max-height: 26rem;
  overflow-y: auto;
}
</style>
